export const chatQuery = {
  eligibilityMessage: 'Check eligibility on my profile',
  eligibilityCode: 'Check eligibility on my profile',

  preApprovalMessage:
    'Review my profile and documents and submit pre-approval request to loan officer',
  preApprovalCode:
    'Review my profile and documents and submit pre-approval request to loan officer',

  loanApplicationMessage: 'Please proceed with my loan application',
  loanApplicationCode: 'Please proceed with my loan application',

  documentUploadMessage: 'Document Uploaded!',
  documentUploadCode: 'Document Uploaded!',
  preUnderwritingMessage: 'Show me the pre-underwriting analysis',
  preUnderwritingCode: 'pre_underwriting_redirect',
};

export const removeMarkersAndJson = (rawMessage) => {
  // Remove %S% and %E% markers from the content
  const content = rawMessage.replace(/%S%|%E%/g, '');
  return content;
};

// Strip the internal "Regenerate:" prefix for DISPLAY only. Regenerate re-asks a
// question with a leading "Regenerate:" marker so the agent redoes it; that marker
// is still sent over the WebSocket to the backend/agent — this only hides it in the
// chat bubble, the same way the backend's "Context:" block is never shown.
export const stripRegeneratePrefix = (rawMessage) =>
  (rawMessage ?? '').replace(/^\s*Regenerate:\s*/i, '');
